module.exports = function(value, plucked) {
	return value.map(function(item) {
	    return item[plucked];
	});
};


// WEBPACK FOOTER //
// ./app/statamic/resources/js/filters/pluck.js